function roundToTwo(value) {
    return Math.round(value * 100) / 100
}

function getRating(name, value) {
    if (name === 'CLS') return value <= 0.1 ? 'good' : value <= 0.25 ? 'needs-improvement' : 'poor'
    if (name === 'INP') return value <= 200 ? 'good' : value <= 500 ? 'needs-improvement' : 'poor'
    if (name === 'LCP') return value <= 2500 ? 'good' : value <= 4000 ? 'needs-improvement' : 'poor'
    if (name === 'FCP') return value <= 1800 ? 'good' : value <= 3000 ? 'needs-improvement' : 'poor'
    if (name === 'TTFB') return value <= 800 ? 'good' : value <= 1800 ? 'needs-improvement' : 'poor'
    return 'unknown'
}

function reportMetric(report, onReport) {
    if (typeof onReport === 'function') onReport(report)
}

export function startWebVitals(onReport) {
    if (typeof window === 'undefined' || typeof PerformanceObserver === 'undefined') return () => {}

    let clsValue = 0
    let inpValue = 0
    const cleanups = []

    try {
        const lcpObserver = new PerformanceObserver((entryList) => {
            const entries = entryList.getEntries()
            const last = entries[entries.length - 1]
            if (!last) return
            const value = roundToTwo(last.startTime)
            reportMetric({ name: 'LCP', value, rating: getRating('LCP', value), path: window.location.pathname }, onReport)
        })
        lcpObserver.observe({ type: 'largest-contentful-paint', buffered: true })
        cleanups.push(() => lcpObserver.disconnect())
    } catch { }

    try {
        const clsObserver = new PerformanceObserver((entryList) => {
            for (const entry of entryList.getEntries()) {
                if (!entry.hadRecentInput) clsValue += entry.value
            }
            const value = roundToTwo(clsValue)
            reportMetric({ name: 'CLS', value, rating: getRating('CLS', value), path: window.location.pathname }, onReport)
        })
        clsObserver.observe({ type: 'layout-shift', buffered: true })
        cleanups.push(() => clsObserver.disconnect())
    } catch { }

    try {
        const fcpObserver = new PerformanceObserver((entryList) => {
            for (const entry of entryList.getEntries()) {
                if (entry.name !== 'first-contentful-paint') continue
                const value = roundToTwo(entry.startTime)
                reportMetric({ name: 'FCP', value, rating: getRating('FCP', value), path: window.location.pathname }, onReport)
            }
        })
        fcpObserver.observe({ type: 'paint', buffered: true })
        cleanups.push(() => fcpObserver.disconnect())
    } catch { }

    try {
        const navEntries = performance.getEntriesByType('navigation')
        if (navEntries.length > 0) {
            const nav = navEntries[0]
            const value = roundToTwo(nav.responseStart)
            reportMetric({ name: 'TTFB', value, rating: getRating('TTFB', value), path: window.location.pathname }, onReport)
        }
    } catch { }

    try {
        const inpObserver = new PerformanceObserver((entryList) => {
            for (const entry of entryList.getEntries()) {
                if (entry.interactionId === 0) continue
                inpValue = Math.max(inpValue, entry.duration)
            }
            const value = roundToTwo(inpValue)
            reportMetric({ name: 'INP', value, rating: getRating('INP', value), path: window.location.pathname }, onReport)
        })
        inpObserver.observe({ type: 'event', buffered: true, durationThreshold: 40 })
        cleanups.push(() => inpObserver.disconnect())
    } catch { }

    return () => {
        cleanups.forEach((fn) => {
            try { fn() } catch { }
        })
    }
}